export default __webpack_public_path__ + "static/media/FSmile.d92c9692.svg";